<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 99.85 124.813"
    aria-labelledby="Light"
    role="presentation"
  >
    <title
      id="Light"
      lang="en"
    >Light icon</title>
    <g id="Group_13" data-name="Group 13" transform="translate(-208.575 -81.093)">
      <g id="Group_10" data-name="Group 10" transform="translate(160.574 81.092)">
        <g id="Group_9" data-name="Group 9" transform="translate(48.001 0.001)">
          <g id="Group_8" data-name="Group 8" transform="translate(0)">
            <g id="Group_7" data-name="Group 7">
              <path fill="#505050" id="Path_8" data-name="Path 8" d="M171.04,76.2a33.256,33.256,0,0,0-2.79-3.008h-.006A32.986,32.986,0,0,0,145.3,64c-.543,0-1.09.012-1.637.04A33.67,33.67,0,0,0,112,97.076a33.094,33.094,0,0,0,12.354,26.069,6.241,6.241,0,0,1,2.207,4.866v4.637a6.241,6.241,0,0,0,4.16,5.858v2.463a6.2,6.2,0,0,0,1.623,4.16,6.145,6.145,0,0,0,0,8.321,6.18,6.18,0,0,0,2.7,10.072,10.368,10.368,0,0,0,20.448,0,6.18,6.18,0,0,0,2.725-10.072,6.145,6.145,0,0,0,0-8.321,6.2,6.2,0,0,0,1.623-4.16v-2.463a6.241,6.241,0,0,0,4.16-5.858v-4.878a6.2,6.2,0,0,1,2.376-4.757A33.262,33.262,0,0,0,171.04,76.2Zm-25.76,91.808a6.253,6.253,0,0,1-5.885-4.16h11.77A6.253,6.253,0,0,1,145.28,168.011Zm8.321-8.321H136.959a2.08,2.08,0,1,1,0-4.16H153.6a2.08,2.08,0,0,1,0,4.16Zm0-8.321H136.959a2.08,2.08,0,1,1,0-4.16H153.6a2.08,2.08,0,0,1,0,4.16Zm2.08-10.4a2.08,2.08,0,0,1-2.08,2.08H136.959a2.08,2.08,0,0,1-2.08-2.08v-2.08h20.8Zm8.061-21.187v.01a10.341,10.341,0,0,0-3.9,7.978v4.878a2.08,2.08,0,0,1-2.08,2.08H132.8a2.08,2.08,0,0,1-2.08-2.08v-4.637a10.315,10.315,0,0,0-3.744-8.1,28.948,28.948,0,0,1-10.817-22.805,29.458,29.458,0,0,1,27.7-28.915,29.113,29.113,0,0,1,19.881,51.589Z" transform="translate(-95.355 -47.359)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_9" data-name="Path 9" d="M234.081,12.482a2.08,2.08,0,0,0,2.08-2.08V2.081a2.08,2.08,0,0,0-4.16,0V10.4A2.08,2.08,0,0,0,234.081,12.482Z" transform="translate(-184.156 -0.001)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_10" data-name="Path 10" d="M309.035,35.709h0a2.08,2.08,0,0,0,2.841-.763h0l4.16-7.2a2.08,2.08,0,0,0-3.589-2.1l-.014.024-4.16,7.2A2.08,2.08,0,0,0,309.035,35.709Z" transform="translate(-240.391 -18.211)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_11" data-name="Path 11" d="M366.7,100.036l.024-.014,7.2-4.16a2.08,2.08,0,1,0-2.056-3.617l-.024.014-7.2,4.16a2.08,2.08,0,0,0,2.056,3.617Z" transform="translate(-281.531 -68.058)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_12" data-name="Path 12" d="M384,186.081a2.08,2.08,0,0,0,2.08,2.08H394.4a2.08,2.08,0,0,0,0-4.16h-8.321A2.08,2.08,0,0,0,384,186.081Z" transform="translate(-296.632 -136.156)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_13" data-name="Path 13" d="M373.954,264.434l-.024-.014-7.2-4.16a2.08,2.08,0,1,0-2.1,3.589l.024.014,7.2,4.16a2.08,2.08,0,0,0,2.1-3.589Z" transform="translate(-281.531 -192.374)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_14" data-name="Path 14" d="M81.9,260a2.081,2.081,0,0,0-1.04.279l-7.2,4.16a2.08,2.08,0,1,0,2.057,3.617l.024-.014,7.2-4.16A2.08,2.08,0,0,0,81.9,260Z" transform="translate(-66.205 -192.394)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_15" data-name="Path 15" d="M50.081,188.161H58.4a2.08,2.08,0,1,0,0-4.16H50.081a2.08,2.08,0,1,0,0,4.16Z" transform="translate(-48.001 -136.156)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_16" data-name="Path 16" d="M73.637,95.849l.024.014,7.2,4.16a2.08,2.08,0,1,0,2.1-3.589l-.024-.014-7.2-4.16a2.08,2.08,0,0,0-2.1,3.589Z" transform="translate(-66.21 -68.058)"/>
              <path :fill="iconColor" :fill-opacity="opacity" id="Path_17" data-name="Path 17" d="M140.259,27.742l4.16,7.2a2.08,2.08,0,1,0,3.617-2.056l-.014-.024-4.16-7.2a2.08,2.08,0,0,0-3.617,2.056Z" transform="translate(-116.058 -18.211)"/>
            </g>
          </g>
        </g>
        <path :fill="iconColor" :fill-opacity="opacity" id="Path_18" data-name="Path 18" d="M175.583,131.61v.01a10.341,10.341,0,0,0-3.9,7.978v4.878a2.08,2.08,0,0,1-2.08,2.08H144.64a2.08,2.08,0,0,1-2.08-2.08v-4.637a10.315,10.315,0,0,0-3.744-8.1A28.948,28.948,0,0,1,128,108.935a29.458,29.458,0,0,1,27.7-28.915,29.112,29.112,0,0,1,19.881,51.589Z" transform="translate(-59.195 -59.186)"/>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: '#ffd12f'
    },
    level: {
      type: [Number],
      default: 0
    }
  },
  computed:{
    opacity () {
      return this.level / 100   
    }
  }
}
</script>